type Props = {
  value: boolean;
};

export const BooleanValue = ({ value }: Props) => {
  return <i>{value ? "true" : "false"}</i>;
};
